import React from "react";
import FastTextInput from "components/FormElements/FastTextInput";

function DateMetaProperty(props) {
    return <FastTextInput name={props.name} type="date" as="input" />;
}

export default DateMetaProperty;

export const Property = DateMetaProperty;
export const Label = "Date";
